var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.022 12.21a.814.814 0 0 0-.533-1.02c-1.914-.602-2.727-4.03-2.918-5.295-.028-.18-.12-.353-.12-.353-.352-.669-1.683-.981-1.832-1-.27-.031-.304-.237-.315-.307.47-.327.787-1.116.787-1.829C9.091 1.353 8.981.5 7.546.5h-.112C6 .5 5.889 1.353 5.889 2.406c0 .713.317 1.502.787 1.829-.011.07-.056.279-.315.308-.16.018-1.688.379-1.894 1.157 0 0-.025.111-.04.198-.002.012-.16 1.187-.634 2.465-.404 1.09-1.128 2.464-2.282 2.826a.814.814 0 0 0 .235 1.591c-.686.395-.787.945-.787 1.23 0 .113.059.482.327.821.24.305.72.669 1.636.669.138 0 .283-.008.433-.024.61-.066 1.225-.164 1.82-.26l.648-.102c.287-.044.806-.073 1.541-.087h.252c.735.014 1.254.043 1.541.087l.648.102a35.7 35.7 0 0 0 1.82.26c.15.016.295.024.433.024.917 0 1.396-.364 1.636-.669.268-.34.327-.708.327-.821 0-.285-.1-.835-.787-1.23h.011a.815.815 0 0 0 .777-.57Zm-9.512-.103a4.092 4.092 0 0 1-.86.192 32.06 32.06 0 0 0-.444.065c-.183.02-.351.046-.506.077 1.061-.586 1.918-1.704 2.552-3.337a9.5 9.5 0 0 1 .058 1.054c0 1.256-.637 1.898-.8 1.95Zm7.264.257c-.187-.029-.328-.05-.443-.065-1.113-.137-1.66-.885-1.66-2.141 0-.402.023-.766.061-1.095.639 1.66 1.504 2.795 2.58 3.385a5.402 5.402 0 0 0-.538-.084Z",
    fill: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .5)",
    d: "M0 0h15v15H0z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStress);
export default __webpack_public_path__ + "static/media/stress.f82971dd1ef84a44b5ac8beca76ef03a.svg";
export { ForwardRef as ReactComponent };